@if (auth.user$ | async; as user) {
<div class="container mt-5">
  <div class="row align-items-center profile-header mb-5 text-center text-md-left">
    <div class="col-md-2">
      <img [src]="user.picture" class="rounded-circle img-fluid profile-picture mb-3 mb-md-0" />
    </div>
    <div class="col-md">
      <h2>{{ user.name }}</h2>
      <p class="lead text-muted">{{ user.email }}</p>
    </div>
  </div>
  <!-- <div *ngIf="hasApiError" class="alert alert-danger" role="alert">
    {{apiError}}
  </div> -->
  @if (hasApiError) {
  <div class="alert alert-danger" role="alert">
    {{apiErrorDetails}}
  </div>
  }

  @if (taeUser) {
  <h5>You</h5>
  <div class="entity-field-group">
    <div class="label-group entity-field">
      <label class="entity-name">{{user.name}}</label>
      <label class="entity-col1">CPUs:
        {{taeUser.cpu_seconds_remaining}}</label>
      <label class="entity-right">API key: @if (revealApiKey) {
        <span>
          {{taeUser.apiKey}}</span>
        }</label>
      <button class="btn btn-primary entity-danger-button" (click)="toggleRevealApiKey()">{{revealApiKey ? "Hide" :
        "Reveal"}}</button>
    </div>
  </div>
  <h5>Your Organisations</h5>
  <div class="entity-field-group">
    @for (org of this.taeOrgs; track org) {
    <div class="entity-field">
      <div [hidden]="org.editing" class="label-group">
        <label class="entity-name"><a (click)="selectOrg(org)" routerLink="/">{{org.name}}</a></label>
        <label class="entity-col1">CPUs:
          {{org.cpu_seconds_remaining}}</label>
        <label class="entity-right">Invitation code:
          {{org.id}}</label>
        <button class="btn btn-primary entity-danger-button" (click)="leaveOrg(org)">Leave</button>
        <button class="btn btn-primary entity-editfieldbtn" (click)="requestCpuTime(org)">Request CPU time</button>
        <button class="btn btn-primary entity-editfieldbtn" (click)="toggleEditOrg(org)">Edit</button>
      </div>
      <div [hidden]="!org.editing" class="input-group">
        <input type="text" class="form-control" id="invitationCode" [(ngModel)]="org.name" />
        <button class="btn btn-primary entity-midbtn" (click)="updateOrg(org); toggleEditOrg(org);">Save</button>
        <button class="btn btn-primary entity-rhbtn" (click)="toggleEditOrg(org)">Cancel</button>
      </div>
    </div>
    }
  </div>
  }
  <h5>Create/Join Organisations</h5>
  <div class="entity-field-group">
    <div class="input-group entity-field">
      <label for="newOrgName">Organisation Name</label>
      <input type="text" class="form-control" id="newOrgName" [(ngModel)]="createNewOrgName" />
      <button [disabled]="createNewOrgName.length < 2" class="btn btn-primary entity-rhbtn"
        (click)="createOrg()">Create</button>
    </div>
    <div class="input-group entity-field">
      <label for="invitationCode">Invitation code</label>
      <input type="text" class="form-control" id="invitationCode" [(ngModel)]="joinTargetOrgId" />
      <button [disabled]="joinTargetOrgId.length != 24" class="btn btn-primary entity-rhbtn"
        (click)="joinOrg()">Join</button>
    </div>
  </div>
</div>
}